import { Typography } from "@material-ui/core";
import DialogContentText from "@material-ui/core/DialogContentText";
import ActionDialog from "@saleor/components/ActionDialog";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import { BrandErrorFragment } from "@saleor/fragments/types/BrandErrorFragment";
import getBrandErrorMessage from "@saleor/utils/errors/brand";
import React from "react";
import { useIntl } from "react-intl";
interface AssignStatusDialogProps {
  confirmButtonState: ConfirmButtonTransitionState;
  action: string;
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
  error?: BrandErrorFragment;
}

export const AssignStatusDialog: React.FC<AssignStatusDialogProps> = ({
  confirmButtonState,
  open,
  action,
  onConfirm,
  onClose,
  error
}) => {
  const intl = useIntl();
  const errorMessage = getBrandErrorMessage(error, intl);
  let title;
  let message;
  let variant;

  if (action === "ACT") {
    title = "Active Seller";
    message = "Are you sure to activate this seller?";
    variant = "default";
  } else if (action === "INA") {
    title = "Deactivate Seller";
    message = "Are you sure to deactive this seller?";
    variant = "delete";
  } else if (action === "DCL") {
    title = "Decline Seller";
    message = "Are you sure to decline this seller?";
    variant = "delete";
  } else {
    title = "";
    message = "";
    variant = "info";
  }

  return (
    <ActionDialog
      open={open}
      confirmButtonState={confirmButtonState}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      variant={variant}
      confirmButtonLabel="YES"
    >
      <DialogContentText>{message}</DialogContentText>

      {!!errorMessage && <Typography color="error">{errorMessage}</Typography>}
    </ActionDialog>
  );
};

export default AssignStatusDialog;
